import React__default from 'react';

var useDropTarget = function useDropTarget(onDrop) {
  var _React$useState = React__default.useState(false),
      isDraggedOver = _React$useState[0],
      setDraggedOver = _React$useState[1];

  var handleDragEnter = React__default.useCallback(function (event) {
    event.preventDefault();
    setDraggedOver(true);
  }, []);
  var handleDragLeave = React__default.useCallback(function (event) {
    event.preventDefault();

    if (event.target === event.currentTarget) {
      setDraggedOver(false);
    }
  }, []);
  var handleDragOver = React__default.useCallback(function (event) {
    event.preventDefault();
  }, []);
  var handleDrop = React__default.useCallback(function (event) {
    event.preventDefault();
    event.persist();
    setDraggedOver(false);

    if (onDrop) {
      onDrop(event);
    }
  }, [onDrop]);
  var props = onDrop ? {
    onDragEnter: handleDragEnter,
    onDragLeave: handleDragLeave,
    onDragOver: handleDragOver,
    onDrop: handleDrop
  } : undefined;
  return [isDraggedOver, props];
};

export { useDropTarget };
//# sourceMappingURL=useDropTarget.js.map
